<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="!data">{{ $t('Add Collaborator') }}</span>
			<span v-else>{{ $t('Edit Collaborator') }}</span>
		</template>
		<template slot="body">
			<form @submit.prevent="save">
				<!-- Fullname -->
				<div class="form-group">
					<label>{{ $t('Fullname') }}</label>
					<input type="text" name="name" class="form-control" v-model="fullname" required>
				</div>
				<!-- Email -->
				<div class="form-group">
					<label>{{ $t('Email') }}</label>
					<input type="email" name="email" class="form-control" v-model="email" required>
					<span v-if="!isValidEmailAddress && email !== ''" class="text-danger text-small">{{$t('Invalid Email Address')}}</span>
				</div>
				<!-- Role -->
				<div class="form-group select mb-2">
					<label>{{ $t('Role') }}</label>
					<div class="mh-40px">
						<multiselect class="select-input" v-model="role" deselect-label="Can't remove this value" track-by="label" label="label"
						placeholder=" " :options="roles" :searchable="false" :allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						</multiselect>
					</div>
				</div>
				<!-- yaya -->
				<!-- Package Id -->
				<!-- <div class="form-group roles">
					<label class="typo__label">Package </label><label class="ml-1 text-small">(optional)</label>
					<div class="mh-40px">
						<multiselect class="roles-input" v-model="packageData" deselect-label="Can't remove this value" track-by="name" label="name"
							placeholder=" " :options="itemsPackages" :searchable="true" :allow-empty="false" :show-labels="false">
							<span class="arrow-multiselect" slot="caret">
								<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
							</span>
							<span slot="noResult">Oops! No package found.</span>
						</multiselect>
					</div>
				</div> -->
				<!-- Rundown Ids -->
				<div class="form-group rundown-collab">
					<label class="typo__label">Outputs</label>
					<div class="mb-3">
						<multiselect class="rundown-collab-input" v-model="outputIds" tag-placeholder=""
							placeholder="Search or add an Output" label="name" track-by="id"
							:options="outputs" :multiple="true" :searchable="true" @tag="addTagOutput" :show-labels="false">
							<span class="arrow-multiselect" slot="caret">
								<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
							</span>
							<span slot="noResult">Oops! No Output found.</span>
						</multiselect>
					</div>
					<label class="typo__label">Rundowns</label>
						<div>
							<multiselect class="rundown-collab-input" v-model="rundownIds" tag-placeholder=""
								placeholder="Search or add a Rundown" label="name" track-by="id"
								:options="filteredRundown" :multiple="true" :searchable="true" @tag="addTag" :show-labels="false">
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
								<span slot="noResult">Oops! No Rundown found.</span>
							</multiselect>
						</div>
					</div>
				<!-- Access -->
				<!-- <div class="form-group mb-4" v-if="mineRole === 'admin' || roleUser.includes('super_admin')">
					<label>{{ $t('Access') }}</label>
					<input type="text" name="access" class="form-control" v-model="access">
				</div> -->
				<!-- Submit -->
				<button
					:disabled="!isValid"
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving }">
					<span v-if="!data">{{ $t('Create Collaborator') }}</span>
					<span v-else>{{ $t('Update Collaborator') }}</span>
				</button>
			</form>
		</template>
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage, isValidEmail } from '@/lib/helper';
import collaboratorsApi from '@/api/collaborators';
import rundownsApi from '@/api/rundowns';
import displaysApi from '@/api/displays';

export default {
	name: 'CollaboratorForm',
	props: {
		data: {
			type: Object,
		},
		rundownParent: {
		},
		outputParent: {
		},
		mineRole: {
			type: String,
		},
	},
	components: {
		Modal,
		Multiselect,
	},
	data() {
		return {
			email: '',
			password: '',
			fullname: '',
			phone: '',
			isVerified: false,
			lang: 'en',
			picture: '',
			access: '',
			role: 'admin',
			roles: [
				{ key: 'event_manager', label: 'Creator' },
				{ key: 'operator', label: 'Operator' },
			],
			isSaving: false,
			rundowns: [],
			rundownIds: [],
			isFetching: false,
			// output
			outputs: [],
			outputIds: [],
			isFetchingOutput: false,
		};
	},
	methods: {
		// rundown
		fetchRundown() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.rundowns = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			const paramsRundown = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				is_archived: 1,
				user_id: this.user.id,
			};
			rundownsApi.getList(paramsRundown, callback, errorCallback);
		},
		addTag() {
			this.rundowns.push();
			this.rundownIds.push();
		},
		// output
		fetchOutput() {
			this.isFetchingOutput = true;
			const callback = (response) => {
				const items = response.data;
				this.outputs = items;
				this.isFetchingOutput = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetchingOutput = false;
			};
			const paramsOutput = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				is_mine: true,
			};
			displaysApi.getList(paramsOutput, callback, errorCallback);
		},
		addTagOutput() {
			this.outputs.push();
			this.outputIds.push();
		},
		// collaborator
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const user = response.data;
				const message = response.message;
				this.$emit('saved', user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add User',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				collaboratorsApi.update(this.data.id, params, callback, errorCallback);
			} else {
				collaboratorsApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.fetchRundown();
				this.fetchOutput();
				this.setData(this.data);
			}
		},
		reset() {
			this.email = '';
			this.fullname = '';
			this.phone = '';
			this.isVerified = false;
			this.role = this.roles[0];
			this.picture = '';
			this.lang = 'en';
			this.access = '';
			this.rundownIds = '';
			this.outputIds = '';
		},
		setData(data) {
			// get rundown
			const rundowns = JSON.parse(data.rundown_ids);
			const rundownObj = [];
			if (rundowns.length > 0) {
				for (let index = 0; index < rundowns.length; index++) {
					const rundown = rundowns[index];
					const rundownResult = this.searchRundown(rundown, this.rundownParent);
					if (rundownResult && rundownResult.id) {
						rundownObj.push(rundownResult); // eslint-disable-line no-param-reassign
					}
				}
			}
			// get output
			const outputObj = [];
			if (data && data.display_ids) {
				const outputs = JSON.parse(data.display_ids);
				if (outputs.length > 0) {
					for (let index = 0; index < outputs.length; index++) {
						const output = outputs[index];
						const outputResult = this.searchOutput(output, this.outputParent);
						if (outputResult && outputResult.id) {
							outputObj.push(outputResult); // eslint-disable-line no-param-reassign
						}
					}
				}
			}
			// set data
			this.email = data.email;
			this.fullname = data.name;
			this.phone = data.phone;
			const index = this.roles.findIndex(({ key }) => key === data.role);
			this.role = this.roles[index];
			this.picture = data.picture;
			this.lang = data.language;
			this.access = data.access;
			this.rundownIds = rundownObj;
			this.outputIds = outputObj;
		},
		searchRundown(id, rundowns) {
			for (let i = 0; i < rundowns.length; i++) {
				if (rundowns[i].id === id) {
					return rundowns[i];
				}
			}
			return rundowns;
		},
		searchOutput(id, outputs) {
			for (let i = 0; i < outputs.length; i++) {
				if (outputs[i].id === id) {
					return outputs[i];
				}
			}
			return outputs;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		userId() {
			return this.user && this.user.id ? this.user.id : '';
		},
		params() {
			const rundowns = [];
			const outputs = [];
			for (let index = 0; index < this.rundownIds.length; index++) {
				const id = this.rundownIds[index].id;
				rundowns.push(id);
			}
			for (let index = 0; index < this.outputIds.length; index++) {
				const id = this.outputIds[index].id;
				outputs.push(id);
			}
			const email = this.email.trim();
			const fullname = this.fullname.trim();
			// const access = this.access;
			const params = {
				email,
				name: fullname,
				role: this.role.key,
				rundown_ids: JSON.stringify(rundowns),
				display_ids: JSON.stringify(outputs),
			};
			return params;
		},
		roleUser() {
			const role = JSON.parse(this.user.roles);
			return role;
		},
		filteredRundown() {
			const filter = item => (item.is_disabled !== 1);
			return this.rundowns.filter(filter);
		},
		isValid() {
			return this.fullname !== ''
				&& this.email !== ''
				&& (this.rundownIds.length !== 0 || this.outputIds.length !== 0)
				&& isValidEmail(this.email);
		},
		isValidEmailAddress() {
			return isValidEmail(this.email);
		},
	},
	created() {
		this.fetchRundown();
		this.fetchOutput();
		this.initData();
	},
	watch: {
		fullname(val) {
			this.fullname = val.replace(/[^A-Z0-9 ]/gi, '');
		},
	},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
